import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/Core/services/notification.service';
import { ToasterService } from 'src/app/Core/services/toaster.service';

@Component({
  selector: 'app-edit-notification',
  templateUrl: './edit-notification.component.html',
  styleUrls: ['./edit-notification.component.css']
})
export class EditNotificationComponent implements OnInit {
  notificationId: string = '';
  state: string = '';
  subState: string = '';
  createdTime: string = '';
  updatedTime: string = '';
  createdBy: string = '';
  updatedBy: string = '';
  pushData: { language: string; push_title: string; push_body: string; redirect_url: string; }[] = [];
  originalNotification: any = {};
  errorMessage: string;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private toaster: ToasterService
  ) {}

  ngOnInit() {
    const notification = this.notificationService.getNotificationData();
  
    if (notification) {
      this.notificationId = notification.id || '';
      this.state = notification.state || '';
      this.subState = notification.sub_state || '';
      this.createdTime = notification.created_time || '';
      this.updatedTime = notification.updated_time || '';
      this.createdBy = notification.created_by || '';
      this.updatedBy = notification.updated_by || '';
  
      this.originalNotification = JSON.parse(JSON.stringify(notification)); 
  
      if (notification.push) {
        if (notification.push.en) {
          this.pushData.push({
            language: 'English',
            push_title: notification.push.en.push_title || '',
            push_body: notification.push.en.push_body || '',
            redirect_url: notification.push.en.redirect_url || ''
          });
        }
  
        if (notification.push.fr) {
          this.pushData.push({
            language: 'French',
            push_title: notification.push.fr.push_title || '',
            push_body: notification.push.fr.push_body || '',
            redirect_url: notification.push.fr.redirect_url || ''
          });
        }
      }
    } else {
      console.error('No notification data found');
    }
  }
  
  navigateBack() {
    this.router.navigate(["/notification-list"]);
  }

  update() {
    this.errorMessage = '';
    if (!this.hasChanges()) {
      this.errorMessage = "No field has been updated";
      return;
    }
    for (const pushItem of this.pushData) {
      if (!this.isValidUrl(pushItem.redirect_url)) {
        this.errorMessage = "Enter a valid URL for " + pushItem.language;
        return;
      }
    }
  
    const currentPushObject = this.constructPushObject();
  
    const requestBody = { push: currentPushObject };
  
    this.notificationService.updateNotification(this.notificationId, requestBody).subscribe(
      response => {
        this.toaster.openDialogBox("Push notification data updated successfully", true);
      },
      error => {
        console.error('Error updating push data', error);
        if (error.status === 403) {
          this.toaster.openDialogBox("You don't have the required permission", false);
        } else if (error.status === 400) {
          this.toaster.openDialogBox("This notification is already published", false);
        } else {
          this.toaster.openDialogBox("Failed to update push data", false);
        }
      }
    );
  }
  
  public hasChanges(): boolean {
    return JSON.stringify(this.constructPushObject()) !== JSON.stringify(this.constructPushObject(this.originalNotification));
  }
  
  private constructPushObject(notification?: any): any {
    const push: any = {};

    if (notification && notification.push) {
      if (notification.push.en) {
        push['en'] = {
          push_title: notification.push.en.push_title || '',
          push_body: notification.push.en.push_body || '',
          redirect_url: notification.push.en.redirect_url || ''
        };
      }
  
      if (notification.push.fr) {
        push['fr'] = {
          push_title: notification.push.fr.push_title || '',
          push_body: notification.push.fr.push_body || '',
          redirect_url: notification.push.fr.redirect_url || ''
        };
      }
    } else {
      this.pushData.forEach(item => {
        if (item.language === 'English') {
          push['en'] = {
            push_title: item.push_title,
            push_body: item.push_body,
            redirect_url: item.redirect_url
          };
        }
        if (item.language === 'French') {
          push['fr'] = {
            push_title: item.push_title,
            push_body: item.push_body,
            redirect_url: item.redirect_url
          };
        }
      });
    }

    return push;
  }  

  private isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }
}
